import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { getButtonStyles } from '@sc/shared-ui';
import type { ContentBlock } from '../assets/data/caseStudies';
import BlockQuoteIcon from '../assets/icons/blockquote.svg?react';

export function ContentBlockRenderer({ block }: { block: ContentBlock }) {
  if (block.type === 'block') {
    const { pre, heading } = block.body;
    const isLarge = block.body.large ?? false;
    const paragraphs = block.body.body;

    return (
      <div className="mb-20 last:mb-0">
        {pre && (
          <p className="font-grotesque text-xl font-bold text-primary-400 uppercase leading-5 mb-4">
            {pre}
          </p>
        )}
        {heading && (
          <h2 className="font-grotesque text-[2rem] leading-[1.25] font-semibold text-white mb-4">
            {heading}
          </h2>
        )}
        {paragraphs.map((paragraph: string, i: number) => (
          <p
            key={i}
            className={`${
              isLarge ? 'text-lg' : 'text-base'
            } leading-7 text-grey-200 mb-4 last:mb-0`}
          >
            {paragraph}
          </p>
        ))}
      </div>
    );
  }

  if (block.type === 'solution') {
    return (
      <div className="mb-20 bg-background-tertiary rounded-md p-8 flex flex-col gap-5 last:mb-0">
        <p className="text-lg leading-7 text-white">{block.body}</p>
        {block.cta && block.url && (
          <a
            href={block.url}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={`${block.cta} (opens in new tab)`}
            {...getButtonStyles({
              type: 'primary',
              size: 'large',
              additionalClassnames: 'gap-x-2 self-start',
            })}
          >
            {block.cta}
            <ArrowRightIcon className="w-4.5 h-4.5" aria-hidden="true" />
          </a>
        )}
      </div>
    );
  }

  return (
    <blockquote className="mb-20 border border-grey-t-700 p-8 space-y-8 border-l-4 border-l-primary-400 last:mb-0">
      <BlockQuoteIcon />
      <p className="font-grotesque text-[1.5rem] leading-8 font-medium text-white">
        &ldquo;{block.text}&rdquo;
      </p>
      {block.author && (
        <div className="flex items-center gap-3">
          {block.avatar && (
            <img
              src={block.avatar}
              alt={block.author}
              className="size-10 rounded-full object-cover"
            />
          )}
          <div>
            <p className="font-open text-sm font-semibold text-white">
              {block.author}
            </p>
            {block.authorRole && (
              <p className="font-open text-sm text-grey-300">
                {block.authorRole}
              </p>
            )}
          </div>
        </div>
      )}
    </blockquote>
  );
}
